export enum View {
  table = "table",
  list = "list",
  file = "file",
}
